import { render, staticRenderFns } from "./TraceabilityResultsItem.vue?vue&type=template&id=bc453b32&scoped=true"
import script from "./TraceabilityResultsItem.vue?vue&type=script&lang=js"
export * from "./TraceabilityResultsItem.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityResultsItem.vue?vue&type=style&index=0&id=bc453b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc453b32",
  null
  
)

export default component.exports